import { TipoDestinatarioEnum } from "@app/shared/enum/tipo-destinatario-enum";
import { TipoRecapitoAnagrafeEnum } from "@app/shared/enum/tipo-recapito-anagrafe-enum";

export class RecapitoDTO {
  idSoggetto: string;
  denominazioneSoggetto: string;
  id: string;
  idRecapito: string;
  denominazioneRecapito: string;
  tipoRecapito: TipoRecapitoAnagrafeEnum;
  tipoDestinatario: TipoDestinatarioEnum;
}
